import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/auth/password-resets/set-password`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const setPassword = {
  post: apiPathFunc(pathBase),
};
